import "core-js/modules/es.array.push.js";
import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import vailcode from "@utils/errcode";
export default {
  name: "popTask",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      isLoading: false,
      total: 0,
      condition: {
        page: 1,
        limit: 15,
        symbol: "",
        user_id: "",
        direction: ""
      },
      time: ["", ""],
      chainList: []
    };
  },
  props: {
    token: {
      type: String,
      default: ""
    },
    chain: {
      type: String,
      default: ""
    },
    user_id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    "$parent.popDetailShow": {
      async handler(newVal, oldVal) {
        if (newVal) {
          let chainList = [];
          let rs = await this.$http.post("/assets/chains", {});
          console.log(rs);
          if (rs.code == 0) {
            chainList = rs.data;
          }
          rs = await this.$http.post("/assets/tokens", {
            chain_id: this.chain_id
          });
          if (rs.code == 0) {
            rs.data.map(item => {
              chainList.map(sitem => {
                if (!sitem.tokens) {
                  sitem.tokens = [];
                }
                if (sitem.id == item.chain) {
                  sitem.tokens.push(item);
                }
                return sitem;
              });
            });
          }
          this.chainList = chainList;
          if (this.token || this.chain) {
            this.condition.symbol = this.token;
            this.condition.chain = this.chain;
          } else {
            this.onChangeToken((this.chainList[0]['tokens'][0]['chain'] || '') + "|" + (this.chainList[0]['tokens'][0]['symbol'] || ''));
          }
          if (this.user_id) {
            this.condition.user_id = this.user_id;
          }
          this.getData();
        } else {
          this.list = [];
          this.condition = {
            page: 1,
            limit: 15,
            symbol: "",
            user_id: "",
            direction: ""
          };
          this.time = ["", ""];
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/userassets/logs", {
        time: this.time,
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.items;
        this.total = rs.data.total;
      }
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getData();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getData();
    },
    onDatePickerInput(val) {
      console.log("onDatePickerInput", val, this.time);
    },
    onChange(e) {
      this.condition.direction = e;
    },
    onChangeToken(e) {
      this.condition.chain = e.split("|")[0] || '';
      this.condition.symbol = e.split("|")[1] || '';
    }
  }
};